import {TableViews} from "../Tables/TableViews";

export default class RunningTotals {

    static initRunningTotals(selector) {
        $(document).ready(function (){


            /** Only apply these event listeners on financials */
            if (window.location.href.indexOf("orders") === -1 && !$('.showOrderForm').length && $('.running-total').length) {

                /**
                 * On load/init iterate each item to add to a total
                 */
                $('.running-total', selector).each(function (index, element) {
                    /** Get the element to apply the price to eg #total box */
                    let TotalElement = $($(element).data('running-total-element'));
                    /** Reset Total */
                    let total = 0;
                    /** Start the totaling */
                    RunningTotals.runningTotals(TotalElement);
                })

                /**
                 * On a change to the item iterate each item to add to a total
                 */
                $('.running-total, .quantity, .item-total', selector).on('change keyup', function () {
                    $('.running-total', selector).each(function (index, element) {
                        let TotalElement = $($(element).data('running-total-element'));
                        let total = 0;
                        RunningTotals.runningTotals(TotalElement);
                    })
                });
            }

            /** Only apply these event listeners on refunds */
            if (window.location.href.indexOf("refunds") != -1 && !$('.showOrderForm').length && $('.inputQuantity').length){

                /** On changes work out the totals of the refund */
                $(document).on('click','.inputQuantity, #inputOverrideRefundAmount, [data-repeater-delete]', function (){
                    /** if not overridden work it out */
                    if (!$('#inputOverrideRefundAmount').is(':checked')) {
                        RunningTotals.refundTotal(selector);
                    }
                });

                /**
                 *  If the user clicks on the button to allow the item back into stock
                 *  enable the input box for amount to return and the stock location
                 */
                $('.inputReturnStock').click((event) => {
                    let $element = $(event.currentTarget), $repeaterRow = $element.closest('[data-repeater-item]')
                    if ($element.is(':checked')) {
                        $('.return_stock', $repeaterRow).show()
                        $('.return_stock input', $repeaterRow).attr('disabled', false);
                        $('.return_stock select', $repeaterRow)[0].selectize.enable();
                    }
                    else {
                        $('.return_stock', $repeaterRow).hide()
                        $('.return_stock input', $repeaterRow).attr('disabled', true);
                        $('.return_stock select', $repeaterRow)[0].selectize.disable();
                    }
                })

                /**
                 *  When order quantity reduced, auto fill the amount to return to stock
                 */
                $('.inputQuantity').click((event) => {
                    let $element = $(event.currentTarget), $repeaterRow = $element.closest('[data-repeater-item]');
                    let max = $element.attr('max');
                    let value = $element.val();

                    $('.stock_quantity', $repeaterRow).val(max - value);
                    $('.stock_quantity', $repeaterRow).attr('max', max - value);

                    /** Allow return to stock only if qty is less than original */
                    if (parseInt(max) > parseInt(value)) {
                        $('.inputReturnStock', $repeaterRow).prop('disabled', false);
                    }
                    else {
                        $('.inputReturnStock', $repeaterRow).prop('disabled', true).prop('checked', false);
                    }
                })

            }

            $('#inputCoupon', selector).on('change', function () {
                RunningTotals.taxAndTotals($('[data-repeater-list="items"] tr', selector));
            })
            $('#inputCreditNotes', selector).on('change', function () {
                RunningTotals.taxAndTotals($('[data-repeater-list="items"] tr:not(:first-child)', selector));
            })
        });
    }

    static runningTotals(TotalElement) {
        /** Reset total */
        let total = 0;
        /** Get id of the totalling element */
        let totalElementID = '#'+TotalElement.attr('id');

        /** Iterate all the items that have the same totalling element eg #total box */
        $(`.running-total[data-running-total-element='${totalElementID}']`).each( function (index, element) {
            /** Default total to 1 */
            let quantity = 1;
            let quantityClass;
            let value;

            /** Find the quantity input box for the item */
            if ((quantityClass = $(element).data('running-quantity')) !== undefined) {
                /** Get the value of the quantity box */
                quantity = $(element).parent().parent().find(quantityClass).val();
            }

            /** Get the value of the price either form of input or a text box */
            if ($(this).is('input')) {
                value = $(element).val()
            } else {
                value = $(element).text()
            }

            /** Handles boxes that are monetary */
            if (isNaN($(element).val())) {
                value = parseFloat(value.replace('£', '').replaceAll(',', '').trim());
            }

            /** Calculate the individual item price with quantity */
            value = value * quantity;

            /** Add the value to the total */
            if (!isNaN(value))
                total += value;

            /** Apply the total to the totalling element */
            TotalElement.text(total);
        })
    }

    static parseMoney(el){
        /** Parse a monatary element and get the value */
        return parseFloat(el.val().replace('£', '').replaceAll(',', '').trim());
    }

    /**
     * Automated calculation of order items totalling and taxes
     *
     * @param selector
     */
    static taxAndTotals(selector) {

        if(!selector.length || $('.showOrderForm').length)
            return false

        if (window.orderItemsReady === false)
            return false

        //Prevent api calls being spammed
        let taxAndTotalUnique = Math.random().toString(36), passTimeout = false;
        window.taxAndTotalUnique = taxAndTotalUnique;

        function x () {
            return new Promise(function (resolve, reject) {
                setTimeout(function () {
                    resolve();
                }, 1000);
            });
        }

        x().then(
                function (result) {

                    if(taxAndTotalUnique != window.taxAndTotalUnique)
                        return false;


                    /** Reset the payload */
                    let APIPayload = [];
                    let APIParams = {};

                    /** Get the selectizes from the page */
                    if ($('#inputBilling').length > 0)
                        APIParams['billing_id'] = $('#inputBilling')[0].selectize.getValue();
                    else if ($('#orderContext').data('billing-id'))
                        APIParams['billing_id'] = $('#orderContext').data('billing-id');
                    if ($('#inputCompany').length > 0)
                        APIParams['company_id'] = $('#inputCompany')[0].selectize.getValue();
                    else if ($('#orderContext').data('company-id'))
                        APIParams['company_id'] = $('#orderContext').data('company-id');
                    if ($('#inputCustomer').length > 0)
                        APIParams['customer_id'] = $('#inputCustomer')[0].selectize.getValue();
                    else if ($('#orderContext').data('customer-id'))
                        APIParams['customer_id'] = $('#orderContext').data('customer-id');
                    if ($('#inputCoupon').length > 0)
                        APIParams['coupon_id'] = $('#inputCoupon')[0].selectize.getValue();
                    if ($('#inputCreditNotes').length > 0)
                        APIParams['credit_notes'] = $('#inputCreditNotes')[0].selectize.getValue();

                    /**
                     *  Around the orders table iterate each item
                     */
                    selector.each((index, el) => {
                        /** Eliminates the repeater templates */
                        if($('.itemType', el).val() === 'product' || $('.itemType', el).val() === 'shipping' || $('.itemType', el).val() === 'misc') {
                            /** Default to the Standard rates tax class from seeders */
                            let tax_class_id = 1;

                            /** Get tax class on the item (won't apply to shipping) */
                            if ($('.inputTaxClass', el).length > 0) {
                                let selectizeValue = $('.inputTaxClass', el)[0].selectize.getValue();
                                if (selectizeValue) {
                                    tax_class_id = selectizeValue;
                                }
                            }

                            /** Push the data extracted to the api payload */
                            APIPayload.push({
                                'id': $('.itemID', el).val() || $('#inputShippingMethods', el).val(),
                                'quantity': $('.inputQuantity', el).val(),
                                'price' : RunningTotals.parseMoney($('.inputItemPrice', el)),
                                'tax_class_id': tax_class_id,
                                'type': $('.itemType', el).val()
                            });
                        }
                    });

                    APIParams['products'] = APIPayload;

                    /** Carry out the AJAX request to get taxes/totals */
                    axios.post('/api/orders/totals', APIParams).then(response => {

                        response.data.products.forEach(function (data, index) {

                            /** Iterate through each item */
                            selector.each((indexEl, el) =>{

                                /** Avoid the repeater template */
                                if(indexEl-1 === index) {

                                    /** Set the total and tax on the item */
                                    $('.item-tax', el).text('£' + data.total.tax);
                                    $('.item-cost', el).text('£' + data.total.subtotal);
                                    $('.item-discount', el).text('£' + data.total.discount);

                                }
                            })
                        })

                        /** Set the overall totalling */
                        $('#total').text(parseFloat(response.data.totals.total - response.data.totals.creditNotes).toFixed(2));
                        $('#credit_note').text(parseFloat(response.data.totals.creditNotes).toFixed(2));
                        $('#discount').text(parseFloat(response.data.totals.discount).toFixed(2));
                        $('#subtotal').text(parseFloat(response.data.totals.subtotal).toFixed(2));
                        $('#tax').text(parseFloat(response.data.totals.tax).toFixed(2));

                        if (response.data.doesntRequirePayment){
                            $('#total').text(parseFloat('0.00').toFixed(2));
                            $('.payment-area').attr('data-credit-note-covers-order', true);
                            $('.payment-area').hide()
                        }
                        else{
                            $('.payment-area').attr('data-credit-note-covers-order', false);
                            $('.payment-area').show()
                        }
                    });
                }
            );

    }

    static refundTotal(selector) {
        /** Get all order items in the list */
        let items =  $('[data-repeater-list="items"]').children();
        /** Reset the payload */
        let APIPayload = [];

        /**
         *  Around the orders-refund table iterate each item
         */
        items.each((index, el) =>{
            /** Check If order_item_id is set */
            if ($('.id', el).val()){
                /** Push item data to the payload */
                APIPayload.push({
                    'id': $('.id', el).val(),
                    'quantity': $('.inputQuantity', el).val()
                });
            }
        })

        /** Carry out the AJAX Request */
        axios.post(`/api/orders/refund-total/${$('#refund_order_id').val()}`, {
            order_items: APIPayload
        }).then(response => {
            /** Show refund amount in the refund input box (which will be disabled) */
            $('.refund-total').val(response.data.total)

            /** Display the amended totals on the page */
            if (response.data.original.total - response.data.total < 0) {
                $('#inputAmendedTotal, #inputAmendedTax, #inputAmendedSubtotal').text(TableViews.monetary(0));
            }
            else{
                $('#inputAmendedTotal').text(TableViews.monetary(response.data.original.total - response.data.total));
                $('#inputAmendedTax').text(TableViews.monetary(response.data.original.tax - response.data.tax));
                $('#inputAmendedSubtotal').text(TableViews.monetary(response.data.original.subtotal - response.data.subtotal));
            }
        });
    }
}
